module.exports = __webpack_public_path__ + "img/presentations.f2c04ec8.svg";